import { CustomerContact } from '@/modules/Customer/types'
import * as yup from 'yup'

export interface CreateAccountForm {
    password: string
    password_confirmation: string
    send_welcome_email: boolean
}

export const createAccountSchema = yup.object().shape({
    password: yup
        .string()
        .min(8, 'Password must be at least 8 characters')
        .required('Password is required'),
    password_confirmation: yup
        .string()
        .oneOf([yup.ref('password')], 'Passwords must match')
        .required('Confirm password is required'),
    send_welcome_email: yup.boolean().required().default(true),
})

export interface ViewEditContactProps {
    data: CustomerContact
    isEditing: boolean
    setIsEditing: (value: boolean) => void
    editFormControl: any
    onSave: (values: CustomerContact) => Promise<void>
    isPending: boolean
    customerId: number
}
